import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import classNames from "classnames";
export const PaneItemTW = (param)=>{
    let { className, title, subtitle, avatar, buttons, truncate = true, previewLoader } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: tailwindMerge("m-0 flex content-between p-4 text-left", className),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "shrink-0",
                children: previewLoader
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex min-w-0 grow items-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        children: avatar
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: classNames("min-w-0 flex-1", truncate && "[&>*]:truncate"),
                        children: [
                            title,
                            subtitle
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "ml-2 flex shrink-0 content-end gap-1",
                children: buttons
            })
        ]
    });
};
